import { defineComponent, ref, toRaw, watch } from 'vue';
import { InputProcessor } from './input-processor';
import { CsvFormField } from './csv-form-field';
import { SelectableData } from '@/presentation/components/scholarship-form/csv-input/selectable-data';

export default defineComponent({
	props: {
		modelValue: CsvFormField,
		selectableData: Array<SelectableData>,
		separator: String,
		placeholder: String,
		disabled: Boolean,
	},
	setup: (props) => {
		const inputString = ref<string>('');

		let prevSelectableData: SelectableData[] | undefined;
		let prevModelValueKeys: string[] | undefined;

		const processInput = (): void => {
			const selectableData = toRaw(props.selectableData);
			const modelValue = toRaw(props.modelValue);

			if (selectableData === undefined || modelValue === undefined) {
				return;
			}

			const processor = new InputProcessor(props.separator);
			const result = processor.process(inputString.value, selectableData);

			modelValue.keys.value = [...result.outputKeys];
			modelValue.unmatchedInput = [...result.unmatchedInput];

			updateInputString();
		};

		const updateInputString = (): void => {
			const selectableData = toRaw(props.selectableData);
			const modelValue = toRaw(props.modelValue);

			if (selectableData === undefined || modelValue === undefined) {
				return;
			}

			inputString.value = new InputProcessor(props.separator).determineInput(
				modelValue.keys.value,
				modelValue.unmatchedInput,
				selectableData
			);
		};

		watch(
			props,
			() => {
				const selectableData = toRaw(props.selectableData);
				const selectableDataInitialized = prevSelectableData === undefined && selectableData !== undefined;
				const selectableDataChanged =
					!selectableDataInitialized && JSON.stringify(prevSelectableData) !== JSON.stringify(selectableData);

				const modelValue = toRaw(props.modelValue);
				const modelValueKeys = modelValue?.keys.value;
				const modelValueKeysChanged = JSON.stringify(prevModelValueKeys) !== JSON.stringify(modelValueKeys);

				if (selectableDataChanged) {
					processInput();
				}

				if (modelValueKeysChanged || selectableDataInitialized) {
					updateInputString();
				}

				prevSelectableData = selectableData;
				prevModelValueKeys = modelValueKeys;
			},
			{ deep: true }
		);

		updateInputString();

		return {
			processInput,
			inputString,
		};
	},
});
